<template>
  <form novalidate @submit.prevent="send">
    <header class="modal-header">Upload photos (optional)</header>
    <LsUploadPhotos :value="images" track-id="return_request_photos-upload_photos" name="images" />
    <footer class="modal-footer">
      <LsButton
        type="submit"
        text="send"
        track-id="return_request_photos-send"
        :loading="dispute.loadingStatus.isUpdating"
      />
    </footer>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  DISPUTE__UPDATE_CURRENT_DISPUTE,
  DISPUTE__OPEN_SUPPORT_TICKET,
  DISPUTE__SUBMIT_DISPUTE,
} from '@/store/types';
import { LsUploadPhotos, LsButton } from '@/components/common';
import { lsUploadPhotosHelper } from '@/helpers';

export default {
  name: 'ReturnRequestPhotos',
  components: { LsUploadPhotos, LsButton },
  data() {
    return {
      images: [],
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([
      DISPUTE__UPDATE_CURRENT_DISPUTE,
      DISPUTE__OPEN_SUPPORT_TICKET,
      DISPUTE__SUBMIT_DISPUTE,
    ]),
    async send() {
      const isUploadValid = lsUploadPhotosHelper.isValidUpload(this.images);
      if (!isUploadValid) return;

      const { dispute_type } = this.dispute.currentDispute;
      if (dispute_type === 'other') {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          images: this.images,
        });
        this[DISPUTE__OPEN_SUPPORT_TICKET]();
      } else {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          images: this.images,
        });
        this[DISPUTE__SUBMIT_DISPUTE]();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  padding-bottom: 30px;
}

footer {
  padding-top: 30px;
}
</style>
